module.exports = __webpack_public_path__ + "img/b69580b03d9684453c3302d39e6b9839.png";